import { render, staticRenderFns } from "./associateRegisterAccount.vue?vue&type=template&id=53d5928b&"
import script from "./associateRegisterAccount.vue?vue&type=script&lang=ts&"
export * from "./associateRegisterAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports